import { param } from "../generated/labels"
import { IOmniaUser, RoleId } from "../user"
import { getUserRole } from "./utils"

export function getUserBusiness(user: IOmniaUser) {

    const role = getUserRole(user)

    if ((role >= RoleId.Agronomist) && user.BusinessId) {

        const b = param.BusinessId().find(i => i.value == user.BusinessId)

        if (b) {
            return {
                BusinessId: user.BusinessId,
                Name: b.text
            }
        }


    }

}
